import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-cream text-ink" data-id="element-0" data-mp="3ihv0wb3a2fha">
      <MetaPixel data-id="element-1" data-mp="3mjzuj9tq7c3x" />
      <main data-id="element-2" data-mp="3mjg8bgx1m1k3">
        <Hero data-id="element-3" data-mp="3mj6lu3b7icj5" />
        <SocialProof data-id="element-4" data-mp="3rcj8i7wbs999" />
        <Testimonials data-id="element-5" data-mp="3rdaqgfx028h2" />
        <ProblemSection data-id="element-6" data-mp="3rcswjpxt86cb" />
        <SystemSection data-id="element-7" data-mp="3relumgucxi8p" />
        <ModulesSection data-id="element-8" data-mp="5opiv1o0k3w" />
        <BonusSection data-id="element-9" data-mp="4wx1t3d72hu" />
        <UrgencySection data-id="element-10" data-mp="56nfhsbnbo2" />
        <PricingSection data-id="element-11" data-mp="7stte3h7l4p" />
        <MoreResults data-id="element-12" data-mp="2zlldgx6hkckm" />
        <GuaranteeSection data-id="element-13" data-mp="2zm4v0cs84yy4" />
        <FAQ data-id="element-14" data-mp="2zmwh8wzxlkbq" />
        <ClosingSection data-id="element-15" data-mp="2zng0ch1bierc" />
        <SummaryTable data-id="element-16" data-mp="33m5be2yvvk7t" />
        <FinalCta data-id="element-17" data-mp="33nq4do5juv3k" />
      </main>
      <Footer data-id="element-18" data-mp="33myix65o2dr0" />
      <PurchaseNotification data-id="element-19" data-mp="33oi1x4ipj2wh" />
    </div>;
}